module.exports = __webpack_public_path__ + "img/empty.77b1e997.jpg";